/**
* This Mixin helps to validate password field and sets password to error data variable based on that.
* It also supports Confirmation password field.
* Currently it's being used on sign up, account/profile and reset password page.
**/
module.exports = {
    data() {
        return {
            password: '',
            error: '',
            errors: {},
            password_confirmation: null
        }
    },

    methods: {
        validatePassword() {
            this.error = '';
            delete this.errors['password'];
            if (
                this.password.length < 6 ||
                this.password.length > 50 ) {
                this.errors['password'] = this.error = 
                    `Password must be at least 6 characters long (up to 50 characters supported).`;
            } else if (this.password_confirmation !== null && this.password != this.password_confirmation) {
                this.error = 'Password must be matched with confirmation password.';
            }
        }
    },

    watch: {
        'password': function() {
            this.validatePassword()
        },

        'password_confirmation': function() {
            this.validatePassword()
        }
    }
} 
